import { useMemo } from "react";

import { caseNoteTemplatesApi } from "@/api";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { TemplateManagement } from "@/pages/system-settings/tabs/templates/template-management/TemplateManagement";
import {
  TemplateManagementConfig,
  TemplateTitleMaxLength,
} from "@/pages/system-settings/tabs/templates/template-management/TemplateManagement.types";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

function CaseNoteTemplatesSettingsInner() {
  const { t } = useTranslation();

  const config = useMemo<TemplateManagementConfig>(
    () => ({
      queryKey: QueryKey.CaseNoteTemplates,
      titleMaxLength: TemplateTitleMaxLength,
      api: {
        getAll: () => caseNoteTemplatesApi.getAllCaseNoteTemplates(),
        create: (values) =>
          caseNoteTemplatesApi.createCaseNoteTemplate({
            createCaseNoteTemplateRequest: { title: values.title, content: values.content },
          }),
        update: (id, values) =>
          caseNoteTemplatesApi.updateCaseNoteTemplate({
            id,
            updateCaseNoteTemplateRequest: { title: values.title, content: values.content },
          }),
        remove: (id) => caseNoteTemplatesApi.deleteCaseNoteTemplate({ id }),
      },
      labels: {
        selectTemplate: t("settings.caseNoteTemplates.selectTemplate"),
        addTemplate: t("settings.caseNoteTemplates.addTemplate"),
        title: t("settings.caseNoteTemplates.title"),
        content: t("settings.caseNoteTemplates.content"),
        noTemplateSelected: t("settings.caseNoteTemplates.noTemplateSelected"),
        noTemplates: t("settings.caseNoteTemplates.noTemplates"),
        saveSuccess: t("settings.caseNoteTemplates.saveSuccess"),
        saveError: t("settings.caseNoteTemplates.saveError"),
        createSuccess: t("settings.caseNoteTemplates.createSuccess"),
        createError: t("settings.caseNoteTemplates.createError"),
        deleteSuccess: t("settings.caseNoteTemplates.deleteSuccess"),
        deleteError: t("settings.caseNoteTemplates.deleteError"),
        deleteConfirmTitle: t("settings.caseNoteTemplates.deleteConfirmTitle"),
        deleteConfirmText: t("settings.caseNoteTemplates.deleteConfirmText"),
      },
    }),
    [t]
  );

  return <TemplateManagement config={config} />;
}

export const CaseNoteTemplatesSettings = withAuthorization(CaseNoteTemplatesSettingsInner, UserPermission.Supervisor);
